import { Component, EventEmitter, inject, Input, Output } from "@angular/core";

import { PluginService } from "@core/services/plugin-service";

interface PluginPromptText {
  title: string;
  body: string;
  cta: string | null;
}

@Component({
  selector: "confect-extension-install-prompt",
  templateUrl: "./extension-install-prompt.component.html",
  standalone: false,
})
export class CExtensionInstallPromptComponent {
  @Input() slim: boolean = false;
  @Input() buttonType: "white" | "primary" | "secondary" = "primary";

  @Output() clicked = new EventEmitter<any>();

  chromeText: PluginPromptText = {
    title: "Confect for Chrome",
    body: "To use multiple designs in the same catalog, you need to install the Confect Chrome Plugin. It allows you to change design variants directly in the Ads Manager. ",
    cta: "Add to Chrome - It's free",
  };

  nonChromeText: PluginPromptText = {
    title: "Confect for Chrome",
    body: "To use multiple designs in the same catalog, you need to install the Confect Chrome Plugin in the Google Chrome browser.",
    cta: null,
  };

  text = this.chromeText;

  pluginService = inject(PluginService);

  constructor() {
    if (!this.pluginService.checkBrowser()) {
      this.text = this.nonChromeText;
    }
  }

  openWebStore() {
    this.clicked.emit();
    window.open(
      "https://chrome.google.com/webstore/detail/confect-analytics/leknliicffobjlhilhmijnbmmjfigjme",
      "_blank",
    );
  }

  openHelp() {
    this.clicked.emit();
    window.open(
      "https://academy.confect.io/articles/read/use-design-variants-in-facebook-ads-manager",
      "_blank",
    );
  }
}
